// src/pages/Dashboard.js
// src/pages/Dashboard.js
import React, { useState } from "react";
import BloodPressureForm from "../components/BloodPressureForm";
import BloodPressureChart from "../components/BloodPressureChart";
import BloodGlucoseForm from "../components/GlucoseForm";
import GlucoseChart from "../components/GlucoseChart";
import A1cForm from "../components/A1cForm";
import A1cChart from "../components/A1cChart";
import WeightForm from "../components/WeightForm";
import WeightChart from "../components/WeightChart";
import "../styles/Dashboard.css";
import ConsentOptions from "../components/ConsentOptions";
import ConsentStatus from "../components/ConsentStatus";

export default function Dashboard() {
  const [bpUpdated, setBpUpdated] = useState(false);
  const [glucoseUpdated, setGlucoseUpdated] = useState(false);
  const [a1cUpdated, setA1cUpdated] = useState(false);

  return (
    <div className="dashboard-container">
      <h1 style={{ fontSize: "2rem", fontWeight: "bold", textAlign: "center" }}>
        Your Health Dashboard
      </h1>

      {/* BLOOD PRESSURE SECTION */}
      <div className="dashboard-card">
        <h2 className="section-title">Blood Pressure</h2>
        <BloodPressureForm onSave={() => setBpUpdated(v => !v)} />
        <div className="chart-container">
          <BloodPressureChart key={bpUpdated} />
        </div>
      </div>

      {/* Divider */}
      <hr className="section-divider" />

      {/* BLOOD GLUCOSE SECTION */}
      <div className="dashboard-card">
        <h2 className="section-title">Blood Glucose</h2>
        <BloodGlucoseForm onSave={() => setGlucoseUpdated(v => !v)} />
        <div className="chart-container">
          <GlucoseChart key={glucoseUpdated} />
        </div>
      </div>

      {/* Divider */}
      <hr className="section-divider" />

      {/* A1C SECTION */}
      <div className="dashboard-card">
        <h2 className="section-title">HbA1c</h2>
        <A1cForm onSave={() => setA1cUpdated(v => !v)} />
        <div className="chart-container">
          <A1cChart key={a1cUpdated} />
        </div>
      </div>

      {/* Divider */}
      <hr className="section-divider" />

      {/* WEIGHT SECTION */}
      <div className="dashboard-card">
        <h2 className="section-title">Weight</h2>
        <WeightForm onSave={() => { /* optional UI refresh */ }} />
        <div className="chart-container">
          <WeightChart />
        </div>
      </div>

      {/* Divider */}
      <hr className="section-divider" />

      {/* CONSENT SECTION */}
      <div className="dashboard-card" style={{ marginTop: "40px" }}>
        <div className="privacy-consent">
          <ConsentOptions />
          <ConsentStatus />
        </div>
      </div>
    </div>
  );
}
